import { IBandUser } from "Bands/types";

export const getMemberName = (
  user: Pick<IBandUser, "nickname" | "firstname" | "lastname">,
  hideNickname?: boolean
) =>
  user
    ? !hideNickname && user.nickname
      ? user.nickname
      : `${user.firstname} ${user.lastname}`
    : "";
